import { crudSelectorsCustom } from 'redux/crudCreatorCustom/selector';
import { MODEL_NAME } from './actions';

export const providersOfUserSelectors = crudSelectorsCustom(MODEL_NAME);
